import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "재귀적 `turbo` 호출",
  "description": "Turborepo에서 재귀 스크립트 및 작업 오류에 대해 자세히 알아보세요."
};
export let structuredData = {
  "contents": [{
    "heading": "이-오류가-발생한-이유",
    "content": "단일 패키지 워크스페이스에서 turbo 호출의 순환이 감지되면 Turborepo는 자기 자신에 대한 재귀 호출을 방지하기 위해 오류를 발생시킵니다. 일반적으로 이러한 상황은 다음 두 가지 이유 중 하나로 발생합니다:"
  }, {
    "heading": "스크립트-및-작업의-재귀",
    "content": "단일 패키지 워크스페이스에서 package.json의 스크립트가 동일한 이름을 가진 Turborepo 작업을 호출하면 루프가 발생합니다."
  }, {
    "heading": "스크립트-및-작업의-재귀",
    "content": "build 스크립트를 호출하면 turbo run build가 호출됩니다. 그러면 turbo run build가 build 스크립트를 호출하여 재귀 호출의 루프를 시작합니다."
  }, {
    "heading": "스크립트-및-작업의-재귀",
    "content": "이를 해결하려면 package.json의 스크립트 이름이 Turborepo 작업과 동일하지 않도록 해야 합니다. 예를 들어, 위의 코드를 수정하려면 스크립트 이름을 변경하여 순환을 끊을 수 있습니다:"
  }, {
    "heading": "패키지-매니저-워크스페이스-잘못된-구성",
    "content": "잘못 구성된 워크스페이스는 다중 패키지 워크스페이스가 단일 패키지 워크스페이스처럼 보이게 만들 수 있습니다. 이로 인해 Turborepo는 리포지토리 유형을 잘못 추론하여 package.json의 스크립트가 재귀적이라고 판단합니다."
  }, {
    "heading": "패키지-매니저-워크스페이스-잘못된-구성",
    "content": "리포지토리가 이 상태가 되는 몇 가지 방법이 있으며, 가장 일반적인 것은 패키지 매니저에 따라 패키지가 정의되지 않은 경우입니다. package.json에 workspaces 필드가 누락된 npm 워크스페이스나 pnpm-workspace.yaml 파일이 누락된 pnpm 워크스페이스는 이 오류 메시지를 발생시킬 수 있습니다."
  }, {
    "heading": "패키지-매니저-워크스페이스-잘못된-구성",
    "content": "리포지토리가 다중 패키지 워크스페이스 표준을 준수하는지 확인하고 문제를 수정하세요."
  }],
  "headings": [{
    "id": "이-오류가-발생한-이유",
    "content": "이 오류가 발생한 이유"
  }, {
    "id": "스크립트-및-작업의-재귀",
    "content": "스크립트 및 작업의 재귀"
  }, {
    "id": "패키지-매니저-워크스페이스-잘못된-구성",
    "content": "패키지 매니저 워크스페이스 잘못된 구성"
  }]
};
export const toc = [{
  depth: 2,
  url: "#이-오류가-발생한-이유",
  title: _jsx(_Fragment, {
    children: "이 오류가 발생한 이유"
  })
}, {
  depth: 3,
  url: "#스크립트-및-작업의-재귀",
  title: _jsx(_Fragment, {
    children: "스크립트 및 작업의 재귀"
  })
}, {
  depth: 3,
  url: "#패키지-매니저-워크스페이스-잘못된-구성",
  title: _jsx(_Fragment, {
    children: "패키지 매니저 워크스페이스 잘못된 구성"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    p: "p",
    pre: "pre",
    span: "span",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      id: "이-오류가-발생한-이유",
      children: "이 오류가 발생한 이유"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://turborepo.com/docs/guides/single-package-workspaces",
        children: "단일 패키지 워크스페이스"
      }), "에서 ", _jsx(_components.code, {
        children: "turbo"
      }), " 호출의 순환이 감지되면 Turborepo는 자기 자신에 대한 재귀 호출을 방지하기 위해 오류를 발생시킵니다. 일반적으로 이러한 상황은 다음 두 가지 이유 중 하나로 발생합니다:"]
    }), "\n", _jsx(_components.h3, {
      id: "스크립트-및-작업의-재귀",
      children: "스크립트 및 작업의 재귀"
    }), "\n", _jsxs(_components.p, {
      children: ["단일 패키지 워크스페이스에서 ", _jsx(_components.code, {
        children: "package.json"
      }), "의 스크립트가 동일한 이름을 가진 Turborepo 작업을 호출하면 루프가 발생합니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"turbo run build\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "build"
      }), " 스크립트를 호출하면 ", _jsx(_components.code, {
        children: "turbo run build"
      }), "가 호출됩니다. 그러면 ", _jsx(_components.code, {
        children: "turbo run build"
      }), "가 ", _jsx(_components.code, {
        children: "build"
      }), " 스크립트를 호출하여 재귀 호출의 루프를 시작합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["이를 해결하려면 ", _jsx(_components.code, {
        children: "package.json"
      }), "의 스크립트 이름이 Turborepo 작업과 동일하지 않도록 해야 합니다. 예를 들어, 위의 코드를 수정하려면 스크립트 이름을 변경하여 순환을 끊을 수 있습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build:app\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"turbo run build\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "패키지-매니저-워크스페이스-잘못된-구성",
      children: "패키지 매니저 워크스페이스 잘못된 구성"
    }), "\n", _jsxs(_components.p, {
      children: ["잘못 구성된 워크스페이스는 ", _jsx(_components.a, {
        href: "https://vercel.com/docs/vercel-platform/glossary#multi-package-workspace",
        children: "다중 패키지 워크스페이스"
      }), "가 단일 패키지 워크스페이스처럼 보이게 만들 수 있습니다. 이로 인해 Turborepo는 리포지토리 유형을 잘못 추론하여 ", _jsx(_components.code, {
        children: "package.json"
      }), "의 스크립트가 재귀적이라고 판단합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["리포지토리가 이 상태가 되는 몇 가지 방법이 있으며, 가장 일반적인 것은 ", _jsx(_components.a, {
        href: "https://turborepo.com/docs/crafting-your-repository/structuring-a-repository#specifying-packages-in-a-monorepo",
        children: "패키지 매니저에 따라 패키지가 정의되지 않은 경우"
      }), "입니다. ", _jsx(_components.code, {
        children: "package.json"
      }), "에 ", _jsx(_components.code, {
        children: "workspaces"
      }), " 필드가 누락된 npm 워크스페이스나 ", _jsx(_components.code, {
        children: "pnpm-workspace.yaml"
      }), " 파일이 누락된 pnpm 워크스페이스는 이 오류 메시지를 발생시킬 수 있습니다."]
    }), "\n", _jsx(_components.p, {
      children: "리포지토리가 다중 패키지 워크스페이스 표준을 준수하는지 확인하고 문제를 수정하세요."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
